import { render, staticRenderFns } from "./SolutionsProvidedBeck.vue?vue&type=template&id=9715ff26&scoped=true"
import script from "./SolutionsProvidedBeck.vue?vue&type=script&lang=js"
export * from "./SolutionsProvidedBeck.vue?vue&type=script&lang=js"
import style0 from "./SolutionsProvidedBeck.vue?vue&type=style&index=0&id=9715ff26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9715ff26",
  null
  
)

export default component.exports